import { defineRecipe } from '@chakra-ui/react'

export const containerRecipe = defineRecipe({
    variants: {
        variant: {
            server: {
                paddingInline: 'unset',
                paddingBlock: 'unset',

                borderRadius: '4px',
                padding: '12px 16px',
                _light: {
                    background: 'rgba(84, 79, 64, 0.08)',
                },
                _dark: {
                    background: '#202020',
                },
            },
            user: {
                paddingInline: 'unset',
                paddingBlock: 'unset',

                borderRadius: '4px',
                padding: '12px 16px',
                _light: {
                    background: 'dark.700',
                    color: 'white',
                },
                _dark: {
                    bgColor: 'surface.dark',
                    color: 'dark.700',
                },
            },
            citations: {
                paddingInline: 'unset',
                paddingBlock: 'unset',

                borderBottomRadius: '4px',
                padding: '0 16px 12px 16px',
                _light: {
                    background: 'rgba(84, 79, 64, 0.08)',
                },
                _dark: {
                    bgColor: '#202020',
                },
            },
        },
    },
})
